/**
 * Single source of truth for WhatsApp order & contract forwarding
 * Target Phone: +989128634908 (Arash Kavianipoor / Sorena IT)
 */

export const WHATSAPP_PHONE_RAW = '989128634908';
export const WHATSAPP_PHONE_FORMATTED = '+989128634908';
export const WHATSAPP_PHONE_DISPLAY = '+98 912 863 4908';

export function createWhatsAppUrl(message: string): string {
  const encoded = encodeURIComponent(message.trim());
  return `https://wa.me/${WHATSAPP_PHONE_RAW}?text=${encoded}`;
}

export function openWhatsAppChat(message: string): void {
  const url = createWhatsAppUrl(message);
  try {
    const win = window.open(url, '_blank', 'noopener,noreferrer');
    if (!win) {
      window.location.href = url;
    }
  } catch {
    window.location.href = url;
  }
}
